import { config } from "../env";
import {
  Delete,
  DeleteWithPayload,
  get,
  getWithToken,
  patch,
  post,
} from "./helpers/http-handler";

export const adminLogin = (payload: object) =>
  post(`${config.API_URL}/auth/user/email/login`, payload);

export const adminForgotPassword = (payload: object) =>
  post(`${config.API_URL}/auth/user/email/forgot-password`, payload);

export const adminSetPassword = (payload: object) =>
  post(`${config.API_URL}/auth/user/email/set-password`, payload);

export const getEmailFromToken = (payload: object) =>
  post(`${config.API_URL}/auth/user/set-password/get-email`, payload);

export const adminSuperUser = (payload: object) =>
  post(`${config.API_URL}/auth/user/super-user`, payload);

export const clientLogout = (payload: object) =>
  DeleteWithPayload(`${config.API_URL}/auth/user/logout`, payload);

export const clientUpdateToken = (payload: object) =>
  post(`${config.API_URL}/auth/user/refresh`, payload);

export const getCapchaByID = (queryRequest: string) =>
  get(`${config.API_URL}/auth/user/login/captcha?${queryRequest}`);
export const downloadURL = (encoded_key: string) =>
  get(
    `${config.API_URL}/media-uploads/get-download-url?encoded_key=${encoded_key}`
  );

export const validateLoginOTP = (payload: object) =>
  post(`${config.API_URL}/auth/user/otp`, payload);

export const resendLogiOTP = (token: string) =>
  get(`${config.API_URL}/auth/user/resend/otp?mfa_token=${token}`);

export const GetSpecificOrganizationToken = (id: string, token: string) =>
  getWithToken(`${config.API_URL}/organisation/${id}`, token);
